import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotificationState {
    email: boolean;
    bell: boolean;
    browser: boolean;
    popup: boolean;
    soundEnabled: boolean;
    soundName: string;
    loading: boolean;
    error: string | null;
}

const initialState: NotificationState = {
    email: true,
    bell: true,
    browser: false,
    popup: false,
    soundEnabled: false,
    soundName: 'Chime (1 sec)',
    loading: false,
    error: null,
};

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        // Used by component to update UI instantly
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        updateEmail: (state, action: PayloadAction<boolean>) => {
            state.email = action.payload;
        },
        updateBell: (state, action: PayloadAction<boolean>) => {
            state.bell = action.payload;
        },
        updateBrowser: (state, action: PayloadAction<boolean>) => {
            state.browser = action.payload;
        },
        updatePopup: (state, action: PayloadAction<boolean>) => {
            state.popup = action.payload;
        },
        updateSoundEnabled: (state, action: PayloadAction<boolean>) => {
            state.soundEnabled = action.payload;
        },
        updateSoundName: (state, action: PayloadAction<string>) => {
            state.soundName = action.payload;
        },
        resetNotificationState: () => initialState,
    },
});

export const {
    setLoading,
    setError,
    updateEmail,
    updateBell,
    updateBrowser,
    updatePopup,
    updateSoundEnabled,
    updateSoundName,
    resetNotificationState,
} = notificationSlice.actions;

export default notificationSlice.reducer;